import { Link } from 'react-router-dom';

const exportEmail = 'hello@holito.app';

export const DecommissionBanner = () => (
  <div className="rounded-2xl border border-red-200 bg-red-50 px-5 py-4 text-base text-red-950 shadow-sm">
    <strong className="font-bold">Holito Communities is being decommissioned at the end of May 2026.</strong>{' '}
    Thank you for being with us on this journey. We recommend migrating your events and groups to{' '}
    <a
      href="https://lu.ma"
      target="_blank"
      rel="noreferrer"
      className="font-semibold underline"
    >
      lu.ma
    </a>
    . If you need exports, contact{' '}
    <a href={`mailto:${exportEmail}`} className="font-semibold underline">
      {exportEmail}
    </a>
    .
  </div>
);

interface DisabledFeaturePageProps {
  featureName?: string;
}

export const DisabledFeaturePage = ({ featureName = 'This feature' }: DisabledFeaturePageProps) => (
  <div className="mx-auto flex min-h-[60vh] max-w-3xl items-center justify-center px-4 py-12">
    <div className="rounded-2xl bg-white p-8 text-center shadow-custom">
      <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-amber-700">
        Decommission notice
      </p>
      <h1 className="mb-4 text-2xl font-bold text-gray-900">
        {featureName} is no longer available on Holito Communities
      </h1>
      <p className="mb-6 text-gray-600">
        Holito Communities is being decommissioned at the end of May 2026. Thank you for being with us
        on this journey. We recommend migrating your events and groups to lu.ma. If you need exports,
        contact{' '}
        <a href={`mailto:${exportEmail}`} className="font-semibold text-primary-base underline">
          {exportEmail}
        </a>
        .
      </p>
      <div className="flex flex-col justify-center gap-3 sm:flex-row">
        <Link
          to="/communities"
          className="inline-flex items-center justify-center rounded-lg bg-primary-base px-4 py-2 font-bold text-white hover:bg-primary-dark"
        >
          View communities
        </Link>
        <a
          href="https://lu.ma"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center rounded-lg border border-primary-base px-4 py-2 font-bold text-primary-base hover:bg-primary-50"
        >
          Go to lu.ma
        </a>
      </div>
    </div>
  </div>
);
